import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQBUXr8c6d9WryT2nc2DibvGtFtqMf_bA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "promoalert-11788.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "promoalert-11788",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "promoalert-11788.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "535785949475",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:535785949475:web:88bb83e382a8d47d5e6496",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-GK1EGFELTD"
};

export const IS_HOMOLOGACAO = firebaseConfig.projectId === 'promoalert-homologacao';
export const ASAAS_REGION = 'southamerica-east1';
const ASAAS_FUNCTION_NAMES = new Set([
  'gerarAssinaturaPlano', 'gerenciarFaturasCliente', 'cancelarAssinaturaAsaas',
  'obterResumoAssinaturaAsaas', 'obterLinkFaturaAsaas', 'modificarAssinaturaAsaas',
  'agendarRemocaoFilial', 'agendarDowngradePlano', 'webhookAsaas',
]);
export const getFunctionRegion = (functionName) =>
  ASAAS_FUNCTION_NAMES.has(functionName) ? ASAAS_REGION : 'us-central1';
export const getHttpFunctionUrl = (functionName) =>
  `https://${getFunctionRegion(functionName)}-${firebaseConfig.projectId}.cloudfunctions.net/${functionName}`;

// Producao exige MFA. A homologacao o desativa explicitamente no build para
// permitir testes sem depender de SMS ou de Identity Platform.
export const ADMIN_MFA_MODE = process.env.REACT_APP_ADMIN_MFA_MODE || 'required';
export const ADMIN_MFA_REQUIRED = ADMIN_MFA_MODE === 'required';

const app = initializeApp(firebaseConfig);
const appSolicitacaoExclusao = getApps().some((firebaseApp) => firebaseApp.name === 'solicitacao-exclusao')
  ? getApp('solicitacao-exclusao')
  : initializeApp(firebaseConfig, 'solicitacao-exclusao');

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export const functionsAsaas = getFunctions(app, ASAAS_REGION);
// A solicitacao publica usa uma sessao isolada para nunca autenticar o painel comum.
export const authSolicitacaoExclusao = getAuth(appSolicitacaoExclusao);
export const functionsSolicitacaoExclusao = getFunctions(appSolicitacaoExclusao, "us-central1");

export async function postJsonWithAuth(url, body, init = {}) {
  const usuarioAtual = auth.currentUser;

  if (!usuarioAtual) {
    throw new Error("Sessão inválida. Faça login novamente.");
  }

  const idToken = await usuarioAtual.getIdToken();
  if (!idToken) {
    throw new Error("Sessão inválida. Faça login novamente.");
  }

  return fetch(url, {
    method: "POST",
    ...init,
    // O token de identidade é validado pela Function antes de qualquer ação.
    headers: {
      "Content-Type": "text/plain",
    },
    body: JSON.stringify({
      ...(body || {}),
      authToken: idToken,
    }),
  });
}
